module.exports = __webpack_public_path__ + "img/1495119506.d474c494.jpg";